import { createFileRoute, redirect } from '@tanstack/react-router'
import { loginUrl } from '@/shared/api'

// Развилка по роли: сотрудник → доска, заказчик → его проекты. Без session —
// на единый вход хаба (своей страницы входа у deal нет).
export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    if (!context.session) throw redirect({ href: loginUrl(`${window.location.origin}/`) })
    throw redirect({ to: context.session.kind === 'customer' ? '/projects' : '/boards' })
  },
})
